/*!
=========================================================
* Black Dashboard React v1.2.0
=========================================================
* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)
* Coded by Creative Tim
=========================================================
* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import React, { useEffect } from "react";
// import serverUrl from config4js.js
//import { serverUrl } from "../config4js.js";
import ZiroQRCode from '../ZiroLiveQRCode.png';
// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardText,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
} from "reactstrap";

import { connect } from "react-redux";
import { renderChip, notify, renderNames, getCookie } from "./Utils";
import NotificationAlert from "react-notification-alert";
import { Redirect } from "react-router-dom";

function UserProfile(props) {
  const [auth, setAuth] = React.useState(props.auth);
  const [profilePic, setProfilePic] = React.useState(props.imgURL);
  const [firstName, setFirstName] = React.useState("");
  const [lastName, setLastName] = React.useState("");
  const [tagline, setTagline] = React.useState("");
  const notificationAlertRef = React.useRef(null);
  const [description, setDescription] = React.useState("");
  const [username, setUsername] = React.useState("");
  const [city, setCity] = React.useState("");
  const [state, setState] = React.useState("");
  const [country, setCountry] = React.useState("");
  const [zip, setZip] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [userId, setUserID] = React.useState("");
  const log = localStorage.getItem("loggedin");

  function saveProfile() {
    if(props.auth !== 1){
      return;
    }
    var id_token = getCookie("ziroatoken");

    var xhr = new XMLHttpRequest();
    xhr.open(
      "POST",
      "https://zirostudio.appspot.com/saveprofile?authtoken=" + id_token
    );
    xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

    xhr.onload = function () {
      // console.log("Saved profile successfully: " + xhr.responseText);
      if (xhr.responseText == "send_error") {
        // console.log("equal");
        notify(
          "Username taken, choose a new username.",
          notificationAlertRef,
          "warning",
          "tim-icons icon-simple-remove"
        );
        // console.log("here");
        fetchProfile();
      } else {
        notify("Profile saved successfully.", notificationAlertRef);
      }
    };

    // console.log(username);
    // console.log(xhr.responseText);

    xhr.send(
      JSON.stringify({
        first: firstName,
        last: lastName,
        company: tagline,
        description: description,
        tagline: tagline,
        city: city,
        state: state,
        country: country,
        zip: zip,
        username: username,
        email: email,
      })
    );
    console.log(
      JSON.stringify({
        first: firstName,
        last: lastName,
        company: tagline,
        description: description,
        tagline: tagline,
        state: state,
        country: country,
        zip: zip,
        username: username,
        email: email,
      })
    );
  }

  function emptyStringIfNotPresent(dictionary, keys) {
    for (var i = 0; i < keys.length; i++) {
      if (dictionary[keys[i]] === undefined) {
        dictionary[keys[i]] = "";
      }
    }
    return dictionary;
  }

  function fetchProfile() {
    if(props.auth !== 1) {
      return;
    }
    var id_token = getCookie("ziroatoken");

    var xhr = new XMLHttpRequest();
    xhr.open(
      "GET",
      "https://zirostudio.appspot.com/fetchprofile?authtoken=" + id_token
    );

    xhr.onload = function () {
      // console.log("Fetched profile: " + xhr.responseText);
      if (JSON.parse(xhr.responseText)[0] === undefined) {
        return;
      }

      var parsed = emptyStringIfNotPresent(JSON.parse(xhr.responseText)[0], [
        "first_name",
        "last_name",
        "description",
        "username",
        "city",
        "state",
        "country",
        "zip",
        "tagline",
        "email",
        "user_id",
      ]);

      setFirstName(parsed.first_name);
      setLastName(parsed.last_name);
      setDescription(parsed.description);
      setUsername(parsed.username);
      setCity(parsed.city);
      setState(parsed.state);
      setCountry(parsed.country);
      setZip(parsed.zip);
      setTagline(parsed.tagline);
      setEmail(parsed.email);
      setUserID(parsed.user_id);  
    };

    xhr.send();
  }

  function usePrevious(value) {
    const ref = React.useRef();
    useEffect(() => {
      ref.current = value;
    });
    return ref.current;
  }

  const prevAuth = usePrevious(props.auth);

  useEffect(() => {
    fetchProfile();
  }, []);

  useEffect(() => {
    if (prevAuth !== props.auth) {
      fetchProfile();
    }
  });

  return (
    <>
      <div className="react-notification-alert-container">
        <NotificationAlert ref={notificationAlertRef} />
      </div>
      <div className="content">
      {log === "false" && (
        <Redirect to="/explore"/>
      )}
        <Row>
          <Col md="8">
            <Card>
              <CardHeader>
                <h2>Edit Profile</h2>
              </CardHeader>
              <CardBody>
                <Form>
                  <Row>
                    <Col className="pr-md-1" md="6">
                      <FormGroup>
                        <label>First Name</label>
                        <Input
                          value={firstName}
                          placeholder="First"
                          type="text"
                          onChange={(txt) => setFirstName(txt.target.value)}
                        />
                      </FormGroup>
                    </Col>
                    <Col className="pl-md-1" md="6">
                      <FormGroup>
                        <label>Last Name</label>
                        <Input
                          value={lastName}
                          placeholder="Last"
                          type="text"
                          onChange={(txt) => setLastName(txt.target.value)}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="pr-md-1" md="3">
                      <FormGroup>
                        <label>Username</label>
                        <Input
                          placeholder="username"
                          value={username}
                          type="text"
                          onChange={(txt) => setUsername(txt.target.value)}
                        />
                      </FormGroup>
                    </Col>
                    <Col className="px-md-1" md="4">
                      <FormGroup>
                        <label htmlFor="exampleInputEmail1">
                          Email address
                        </label>
                        <Input
                          value={email}
                          type="email"
                          placeholder="e.g. example@zeroui.com"
                          onChange={(txt) => setEmail(txt.target.value)}
                        />
                      </FormGroup>
                    </Col>
                    <Col className="pl-md-1" md="5">
                      <FormGroup>
                        <label>Tagline</label>
                        <Input
                          value={tagline}
                          type="text"
                          placeholder="Tagline"
                          onChange={(txt) => setTagline(txt.target.value)}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="pr-md-1" md="3">
                      <FormGroup>
                        <label>City</label>
                        <Input
                          value={city}
                          placeholder="City"
                          type="text"
                          onChange={(txt) => setCity(txt.target.value)}
                        />
                      </FormGroup>
                    </Col>
                    <Col className="pr-md-1" md="3">
                      <FormGroup>
                        <label>State (if applicable)</label>
                        <Input
                          value={state}
                          placeholder="State"
                          type="text"
                          onChange={(txt) => setState(txt.target.value)}
                        />
                      </FormGroup>
                    </Col>
                    <Col className="px-md-1" md="3">
                      <FormGroup>
                        <label>Country</label>
                        <Input
                          value={country}
                          placeholder="Country"
                          type="text"
                          onChange={(txt) => setCountry(txt.target.value)}
                        />
                      </FormGroup>
                    </Col>
                    <Col className="pl-md-1" md="3">
                      <FormGroup>
                        <label>Zip Code</label>
                        <Input
                          value={zip}
                          type="text"
                          placeholder="Zip"
                          onChange={(txt) => setZip(txt.target.value)}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="8">
                      <FormGroup>
                        <label>About Me</label>
                        <Input
                          cols="80"
                          value={description}
                          placeholder="About me"
                          rows="4"
                          type="textarea"
                          onChange={(txt) => setDescription(txt.target.value)}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                </Form>
              </CardBody>
              <CardFooter>
                <Button
                  className="animation-on-hover"
                  color="success"
                  type="submit"
                  onClick={saveProfile}
                >
                  Save
                </Button>
              </CardFooter>
            </Card>
          </Col>
          <Col md="4">
            <Card className="card-user">
              <CardBody>
                <CardText />
                <div className="author">
                  <div className="block block-one" />
                  <div className="block block-two" />
                  <div className="block block-three" />
                  <div className="block block-four" />
                  <a href="#pablo" onClick={(e) => e.preventDefault()}>
                    <img
                      alt="..."
                      className="avatar"
                      src={props.imgURL || profilePic}
                    />
                  </a>
                  <h3 style={{ marginBottom: 0 }}>
                    {firstName + " " + lastName}
                  </h3>
                  <h4 style={{ marginBottom: 0 }}>{username}</h4>
                  <h4 style={{ marginBottom: 0 }}>{email}</h4>
                  <h4 style={{ marginBottom: 0 }}>
                    {renderNames(city, state, country)}
                  </h4>
                  <h4 style={{ marginBottom: 0 }}>{tagline}</h4>
                  <h4 style={{ marginBottom: 10 }}>{userId}</h4>
                  <div style={{ textAlign: 'center' }}>
                    <a href="#pablo" onClick={(e) => e.preventDefault()}>
                      <img
                        alt="..."
                        className="QRCode"
                        src={ZiroQRCode}
                        width="200"
                        height="230"
                      />
                    </a>
                    <br />
                    <a href="https://buy.ziro.io/b/9AQeXh24Iba35Wg144" style={{ marginTop: '5px' }}>Ziro AI Coach Subscription</a>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

const mapStateToProps = (state) => ({
  imgURL: state.imgURL,
  auth: state.auth,
});

export default connect(mapStateToProps)(UserProfile);
